import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Measure from 'react-measure'
import _ from 'lodash';

import { Button, Tabs, Spinner, ListTile } from 'components'
import { UpgradeModal } from 'features'
import { FaPlusCircle } from 'react-icons/fa'
import { WorkflowTile, ClientTile, AppSelector, SuggestedWorkflowTile } from './components'

import { ClientWorkflow } from 'schema'
import { suggestedWorkflows, userContext } from 'context'
import * as actionCreators from 'store/actions';
import classes from './Dashboard.module.css'

const ContainerNarrow = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1rem;
`

const Header = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0 1rem 0;
`

const Column = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0.5rem;
    /* min-height: 10rem;
    border: 1px solid red; */
`

const Row = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    margin: ${props => props.margin};
`

const Title = styled.div`
    font-weight: bold;
    font-size: 1.5rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`

const Subtitle = styled.div`
    font-weight: bold;
    font-size: 1rem;
    margin: 1rem 0 0rem 0;
`

const Divider = styled.div`
    margin: 0.1rem;
    border-style: solid;
    border-color: var(--secondary-accent-color);
    border-width: 0 0 0 1px;
    align-self: center;
    justify-self: center;
    padding: 1rem 0;
    height: calc(100% - 1rem);
    width: 1px;
    @media (max-width: 800px) {
        height: 1px;
        width: 100%;
        border-width: 0 0 1px 0;
    }
`

const Placeholder = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    border: 2px solid var(--secondary-color);
    background-color: var(--secondary-color);
    padding: 3rem;
    margin: 1rem 0;
    color: var(--secondary-accent-color);
    /* font-weight: bold; */
`

class Dashboard extends Component {
    constructor(props){
        super(props);
        this.state = {
            tab: 'WORKFLOWS',
            // tab: 'APPLICATIONS',
            width: window.innerWidth, height: window.innerHeight, window: null
        }

        // STYLES //
        this.createStyle = {
            backgroundColor: 'var(--focus-color)',
            margin: '0 0.5rem',
            color: 'white'
        }

        this.tabStyle = {
            main: {
                width: '100%',
                backgroundColor: 'var(--secondary-color)'
            },
            tab: {
                width: null,
                padding: '0.4rem'
            }
        }
        // this.props.getWorkflows({ filters: { userId: this.props.uid } })
        // this.props.getClients({ filters: { userId: this.props.uid } })
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight, window: window, body: window.document.body });
    };

    onEdit = (workflow) => {
        this.props.setScreen('EDITOR')
        this.props.setWorkflow(workflow)
    }

    getBlocks = (tab) => {
        // console.log('[getBlocks]', this.props.clients)
        let blocks = []
        if(tab === 'WORKFLOWS') {
            // Title //
            const title = 
            <Row>
                <Title>Workflows</Title>
                <Button text='Create' icon={<FaPlusCircle style={{marginRight: '0.2rem'}}/>} styles={this.createStyle} 
                    onSelect={() => {
                        if(this.props.user['subscription_plan'] === userContext.PLANS.PERSONAL){
                            this.props.setModal(<UpgradeModal trigger='integrations'/>, 'UpgradeModal')
                        } else {
                            this.props.setScreen('EDITOR')
                            this.props.setWorkflow(null)
                        }
                        
                }}/>
            </Row>
            blocks.push(title)

            // Get existing workflows
            blocks.push(<Subtitle>Existing workflows</Subtitle>)
            if(this.props.workflows){
                const workflows = _.sortBy(this.props.workflows, (workflow) => (workflow['direction'] === 'INFLOW' ? workflow['trigger']['client'] : workflow['action']['client']))
                Object.values(workflows).map(workflow => {
                    blocks.push(<WorkflowTile workflow={workflow} 
                        disableOptions={this.state.width < 800}
                        onEdit={() => {
                            if(this.props.user['subscription_plan'] === userContext.PLANS.PERSONAL){
                                this.props.setModal(<UpgradeModal trigger='integrations'/>, 'UpgradeModal')
                            } else {
                                this.onEdit(workflow)
                            }
                        }} 
                        />)
                })
            } else {
                blocks.push(<Spinner styles={{color: 'var(--focus-color)', margin: '1rem'}}/>)
            }

            // Placeholder if no existing workflows
            if(this.props.workflows && Object.values(this.props.workflows).length === 0){
                blocks.push(<Placeholder>No workflows created yet</Placeholder>)
            }

            // Suggested workflows
            blocks.push(<Subtitle>Suggested workflows</Subtitle>)
            blocks.push(...this.getSuggestedWorkflows())

        } else if (tab === 'APPLICATIONS') {
            // Title
            const title = 
            <Row margin='0 0 0.5rem 0'>
                <Title>Connected apps</Title>
                <Button text='Add' icon={<FaPlusCircle style={{marginRight: '0.2rem'}}/>} styles={this.createStyle} 
                    onSelect={() => {
                        if(this.props.user['subscription_plan'] === userContext.PLANS.PERSONAL){
                            this.props.setModal(<UpgradeModal trigger='integrations'/>, 'UpgradeModal')
                        } else {
                            this.props.setModal(<AppSelector/>)
                        }
                    }}/>
            </Row>
            blocks.push(title)

            // Get connected applications
            if(this.props.clients){
                const clients = _.sortBy(this.props.clients, ['client', 'created'])
                Object.values(clients).map(client => {
                    if(client['client'] === 'TRELLO' && client['clientId'] === 'placeholder'){ return }
                    blocks.push(<ClientTile client={client} 
                        onDelete={() => this.props.deleteClient(client, this.props.clients, this.props.workflows)}
                        onEditWorkflow={this.onEdit}/>)
                })
            } else {
                blocks.push(<Spinner styles={{color: 'var(--focus-color)', margin: '1rem'}}/>)
            }

            // Placeholder if no existing applications
            if(blocks.length === 1){
                blocks.push(<Placeholder>No applications connected yet</Placeholder>)
            }

        }
        return blocks
    }

    getSuggestedWorkflows = () => {
        let workflows = suggestedWorkflows(this.props.uid)
        workflows = _.sortBy(workflows, (value) => (value.workflow['direction'] === 'INFLOW' ? value.workflow['trigger']['client'] : value.workflow['action']['client']))

        let blocks = workflows.map(workflow => (
            <SuggestedWorkflowTile title={workflow['title']} 
                subtitle={workflow['subtitle']}
                workflow={workflow['workflow']}
                triggerIcon={workflow['triggerIcon']}
                actionIcon={workflow['actionIcon']}
                onSelect={() => {
                    if(this.props.user['subscription_plan'] === userContext.PLANS.PERSONAL){
                        this.props.setModal(<UpgradeModal trigger='integrations'/>, 'UpgradeModal')
                    } else {
                        this.onEdit(workflow['workflow'])
                    }
                }}/>
        ))

        return blocks
    }

    render() {
        return (
            <div className={classes.Container}>
                {!this.props.workflows && <Spinner styles={{color: 'var(--text-color)'}}/>}
                <Column>{this.getBlocks('WORKFLOWS')}</Column>
                <Column>{this.getBlocks('APPLICATIONS')}</Column>
            </div>
        )
        // if(this.state.width < 800){
        //     return (
        //         <ContainerNarrow>
        //             <Header>
        //                 <Tabs onSelect={(tab) => this.setState({tab: tab})} styles={this.tabStyle}
        //                     options={{WORKFLOWS: 'Workflows', APPLICATIONS: 'Applications'}} 
        //                     selected={this.state.tab}/>
        //             </Header>
        //             {this.getBlocks(this.state.tab)}
        //         </ContainerNarrow>
        //     )
        // } else {
        //     return (
        //         <Container>
        //             {!this.props.workflows && <Spinner styles={{color: 'var(--text-color)'}}/>}
        //             <Column>{this.getBlocks('WORKFLOWS')}</Column>
        //             <Divider/>
        //             <Column>{this.getBlocks('APPLICATIONS')}</Column>
        //         </Container>
        //     )
        // }
        
    }
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        user: state.auth.user,

        workflows: state.integration.workflows,
        clients: state.integration.clients
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getWorkflows: (filters) => dispatch(actionCreators.getWorkflows(filters)),
        getClients: (filters) => dispatch(actionCreators.getClients(filters)),
        deleteClient: (client, clients, workflows, callback) => dispatch(actionCreators.deleteClient(client, clients, workflows, callback)),
        setModal: (element, id) => dispatch(actionCreators.setModal(element, id))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);